const defaultAjaxConfig = {
    url: '',
    method: 'get',
    params: null,
    data: null,
    timeout: 15 * 1000,
    header: {
        'Content-Type': 'application/json',
        // 'Content-Type': 'application/x-www-form-urlencoded'
    },
};
const buildURL = (config) => {
    // 拼接请求参数的变量
    let { url } = config;
    let params = '';
    // 循环用户传递进来的对象格式参数
    const reqParams = config.params || {};
    const optKeys = Object.keys(reqParams);
    if (optKeys.length > 0) {
        // @ts-ignore
        params = optKeys.map((key) => `${key}=${reqParams[key]}`).join('&');
    }
    // 判断请求方式
    if (config.method === 'get' && params) {
        url = url.indexOf('?') === -1 ? `${url}?${params}` : `${url}&${params}`;
    }
    return url;
};
const buildRequestData = (config) => {
    let requestData = config.data || null;
    const contentType = config.header['Content-Type'];
    if (requestData && contentType === 'application/json') {
        // 向服务器端传递json数据格式的参数
        requestData = JSON.stringify(requestData);
    }
    return requestData;
};
class AjaxError {
    constructor(type, message, config, request, response) {
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        }); // 错误类型
        Object.defineProperty(this, "message", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "request", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "response", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.type = type;
        this.message = message;
        config && (this.config = config);
        request && (this.request = request);
        response && (this.response = response);
    }
}
Object.defineProperty(AjaxError, "ERR_ABORT", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 'ERR_ABORT'
}); // 被取消，中断
Object.defineProperty(AjaxError, "ERR_TIMEOUT", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 'ERR_TIMEOUT'
}); // 超时
Object.defineProperty(AjaxError, "ERR_NETWORK", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 'ERR_NETWORK'
}); // 网络错误
Object.defineProperty(AjaxError, "ERR_SERVER", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 'ERR_SERVER'
}); // 服务器错误
/**
 * http请求
 * @param config {
 *                  url:'',//请求地址
 *                  method:'get',//默认是 get; 'post'、'get'
 *                  params:{},//请求参数在拼接在url上面
 *                  data:{},//请求主体被发送的数据,只适用于这些请求方法 'post'
 *                  timeout:15 * 1000,// 超时时间默认15s
 *                  header:{},
 *               }
 */
export function ajax(ajaxConfig) {
    return new Promise((resolve, reject) => {
        const config = Object.assign(Object.assign({}, defaultAjaxConfig), ajaxConfig);
        const requestData = buildRequestData(config);
        const requestHeaders = config.header || {};
        // 创建ajax对象
        let request = new XMLHttpRequest();
        // 配置ajax对象
        request.open(config.method, buildURL(config), true);
        // 设置超时时间/ms
        request.timeout = config.timeout;
        // 设置请求头
        if ('setRequestHeader' in request) {
            Object.keys(requestHeaders).forEach((key) => {
                request.setRequestHeader(key, requestHeaders[key]);
            });
        }
        // 请求成功，200、404、500等
        request.onload = function handleOnLoad() {
            if (!request)
                return;
            // 获取响应头中的数据
            const contentType = 'getResponseHeader' in request ? request.getResponseHeader('content-type') : null;
            // 服务器端返回的数据
            let responseData = request.responseText;
            // 如果响应类型中包含applicaition/json
            if (contentType && /application\/json/i.test(contentType)) {
                // 将json字符串转换为json对象
                responseData = JSON.parse(responseData);
            }
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                config,
                request,
            };
            // 当http状态码等于200的时候
            if (request.status === 200) {
                // 请求成功 调用处理成功情况的函数
                resolve(response);
            }
            else {
                // 请求失败 调用处理失败情况的函数
                reject(new AjaxError(AjaxError.ERR_SERVER, `Server Error:http status=${request.status}`, config, request, response));
            }
            // @ts-ignore
            request = null;
        };
        // 超时
        request.ontimeout = function handleOnTimeout() {
            if (!request)
                return;
            reject(new AjaxError(AjaxError.ERR_TIMEOUT, `Request Timeout:${config.timeout}`, config, request, null));
            // @ts-ignore
            request = null;
        };
        // 网络错误
        request.onerror = function handleOnError() {
            if (!request)
                return;
            reject(new AjaxError(AjaxError.ERR_NETWORK, 'Network Error', config, request, null));
            // @ts-ignore
            request = null;
        };
        // 请求中断
        request.onabort = function handleOnAbort() {
            if (!request)
                return;
            reject(new AjaxError(AjaxError.ERR_ABORT, 'Request Abort', config, request, null));
            // @ts-ignore
            request = null;
        };
        // @ts-ignore
        request.send(requestData);
    });
}
//# sourceMappingURL=ajax.js.map